import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface IInitialState {
  isEmptyAccumulatedTriggerConditions: boolean;
}

const initialState: IInitialState = {
  isEmptyAccumulatedTriggerConditions: false,
};

const accumulatedTriggerConditionsSlice = createSlice({
  initialState,
  name: 'accumulatedTriggerConditionsSlice',
  reducers: {
    setIsEmptyAccumulatedTriggerConditions(
      state: IInitialState,
      action: PayloadAction<
        IInitialState['isEmptyAccumulatedTriggerConditions']
      >
    ) {
      state.isEmptyAccumulatedTriggerConditions = action.payload;
    },
  },
});

export default accumulatedTriggerConditionsSlice.reducer;

export const { setIsEmptyAccumulatedTriggerConditions } =
  accumulatedTriggerConditionsSlice.actions;
